module.exports = vant;


//////////////////
// WEBPACK FOOTER
// external "vant"
// module id = 138
// module chunks = 25